<template>
  <div class="password-input-wrap">
    <el-input
      :value="value"
      type="text"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :class="{ 'password-input--masked': !visible }"
      :name="fieldName"
      autocomplete="one-time-code"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      data-form-type="other"
      data-lpignore="true"
      data-1p-ignore="true"
      @input="handleInput"
      @blur="handleBlur"
      @focus="handleFocus"
    >
      <span
        slot="suffix"
        class="password-input__suffix-btn"
        :title="visible ? '隐藏密码' : '显示密码'"
        @mousedown.prevent
        @click.prevent="toggleVisible"
      >
        <i class="el-input__icon el-icon-view" />
      </span>
    </el-input>
  </div>
</template>

<script>
/** 新增人员/教师时的默认登录密码 */
export const DEFAULT_LOGIN_PASSWORD = '123456';

/**
 * 自定义密码输入框：text + 圆点遮罩，不使用 type="password"，避免浏览器密码管理器弹层。
 */
export default {
  name: 'PasswordInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入密码'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      readonly: true,
      fieldName: 'field_pwd_' + Math.random().toString(36).slice(2, 10)
    };
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
    },
    handleFocus(e) {
      if (this.readonly) {
        this.readonly = false;
      }
      this.$emit('focus', e);
    },
    handleBlur(e) {
      this.$emit('blur', e);
    },
    toggleVisible() {
      if (this.disabled) return;
      this.visible = !this.visible;
    }
  }
};
</script>

<style scoped>
.password-input-wrap {
  width: 100%;
}

.password-input-wrap /deep/ .el-input {
  width: 100%;
}

.password-input-wrap /deep/ .el-input__inner {
  overflow: hidden;
  padding-right: 30px;
}

.password-input-wrap /deep/ .password-input--masked .el-input__inner {
  -webkit-text-security: disc !important;
  text-security: disc;
}

.password-input-wrap /deep/ .el-input__suffix {
  z-index: 2;
}

.password-input__suffix-btn {
  display: inline-flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  color: #c0c4cc;
}

.password-input__suffix-btn:hover {
  color: #909399;
}
</style>
